import { gql } from '@apollo/client';
import type {
  MessagesQuery,
  MessagesQueryVariables,
  MessageQuery,
  CreateMessageMutation,
  CreateMessageMutationVariables,
  UpdateMessageMutation,
  UpdateMessageMutationVariables,
} from '../generated';

export const MESSAGES_QUERY = gql`
  query Messages($active: Boolean, $type: String, $urgency: String) {
    messages(active: $active, type: $type, urgency: $urgency) {
      id
      active
      type
      urgency
      message
    }
  }
`;

export const MESSAGE_QUERY = gql`
  query Message($id: Int!) {
    message(id: $id) {
      id
      active
      type
      urgency
      message
    }
  }
`;

export const CREATE_MESSAGE_MUTATION = gql`
  mutation CreateMessage(
    $active: Boolean
    $type: String
    $urgency: String
    $message: String!
  ) {
    createMessage(
      active: $active
      type: $type
      urgency: $urgency
      message: $message
    ) {
      success
      error
      messageObj {
        id
        active
        type
        urgency
        message
      }
    }
  }
`;

export const UPDATE_MESSAGE_MUTATION = gql`
  mutation UpdateMessage(
    $id: Int!
    $active: Boolean
    $type: String
    $urgency: String
    $message: String
  ) {
    updateMessage(
      id: $id
      active: $active
      type: $type
      urgency: $urgency
      message: $message
    ) {
      success
      error
      messageObj {
        id
        active
        type
        urgency
        message
      }
    }
  }
`;

export type MessagesResponse = MessagesQuery;
export type MessagesVariables = MessagesQueryVariables;
export type MessageResponse = MessageQuery;
export type CreateMessageResponse = CreateMessageMutation;
export type CreateMessageVariables = CreateMessageMutationVariables;
export type UpdateMessageResponse = UpdateMessageMutation;
export type UpdateMessageVariables = UpdateMessageMutationVariables;

export type Message = NonNullable<NonNullable<MessagesQuery['messages']>[number]>;
